import './Cookies.css'
import React from 'react'

class Cookies extends React.Component {
  render = () => {
    return (
      <div className='cookies'>
        <div className='title'>Cookies</div>
        <div className='desc'>We use cookies on www.boysboysboysboys.com.</div>
        <button onClick={() => { this.props.setCookies(true) }}>I accept.</button>
      </div>
    )
  }
}

export default Cookies
